import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardTile } from './DashboardTile';
import { tokens } from '../../../design';

/**
 * Placeholder tile for the analytics widgets that have NO backend yet
 * (GMV chart, order-status donut, "online сейчас", hourly-orders bars,
 * moderation-latency heatmap, moderator-activity feed).
 *
 * Renders the tile label + a subtle "Скоро" chip over a muted MUI
 * `<Skeleton>` — NO hardcoded mock numbers (the AUT-37 hardcoded-value
 * trap). Grid placement mirrors `design/mockups/admin/dashboard.html`.
 */
export interface ComingSoonTileProps {
  label: string;
  gridColumn: string;
  gridRow?: string;
}

export const ComingSoonTile = ({
  label,
  gridColumn,
  gridRow,
}: ComingSoonTileProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <DashboardTile sx={{ gridColumn, gridRow }}>
      <Typography
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          fontSize: 10,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '1px',
          color: tokens.text.tertiary,
          mb: 1.5,
        }}
      >
        {label}
        <Typography
          component="span"
          sx={{
            fontSize: 10,
            fontWeight: 700,
            textTransform: 'none',
            letterSpacing: 0,
            padding: '2px 8px',
            borderRadius: 999,
            color: tokens.text.tertiary,
            background: tokens.surface.muted,
          }}
        >
          {t('common.comingSoon')}
        </Typography>
      </Typography>
      <Skeleton variant="rounded" animation={false} sx={{ flex: 1, minHeight: 60, bgcolor: tokens.surface.elevated }} />
    </DashboardTile>
  );
};
